import { render, staticRenderFns } from "./Tutoriales.vue?vue&type=template&id=2b7011c0&"
import script from "./Tutoriales.vue?vue&type=script&lang=js&"
export * from "./Tutoriales.vue?vue&type=script&lang=js&"
import style0 from "./Tutoriales.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports